import Vue from "vue";
import Router from "vue-router";
import Login from "../views/Login.vue";
import OTA from "../views/Ota.vue";
// import QrGeneratorIDP from "../views/qr/QrGeneratorIDP.vue";
import { fireCurrentUser } from "../config/firebaseInit";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "qrgenidpstgfrn",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGenIDPSTGFRN.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/ota",
      name: "ota",
      component: OTA,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/flags",
      name: "flags",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/Flags.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/dkerrors",
      name: "dkerrors",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/digitalkey/DKErrorCodes.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/qrdk",
      name: "qrdk",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/qr/QrDK.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        requiresGuest: false,
      },
    },
    {
      path: "/hexascii",
      name: "HexAscii",
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/HexAscii.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/haveoneapp",
      name: "haveoneapp",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/HaveOneApp.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/downloadoneapp",
      name: "downloadoneapp",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/DownloadOneApp.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/enterphonenumber",
      name: "enterphonenumber",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/EnterPhoneNumber.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    // {
    //   path: "/qridp",
    //   name: "qrgeneratoridp",
    //   component: () =>
    //     import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDP.vue"),
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: "/qridpsl",
      name: "qrgeneratoridpsl",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDP_SL.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qridpgl",
      name: "qrgeneratoridpgl",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDP_GL.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qridpstg",
      name: "qrgeneratoridpstg",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDPSTG.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qridpstgtest",
      name: "qrgeneratoridpstgtest",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDPStgTest.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qridpqa",
      name: "qrgeneratoridpqa",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDPQA.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qridpqa-prev",
      name: "qrgeneratoridpqaprev",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDPQAPrev.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qridpau",
      name: "qrgeneratoridpua",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/QrGeneratorIDPAU.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/scan",
      name: "scan",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/Scan.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/scantwo",
      name: "scantwo",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/ScanTwo.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/scanthree",
      name: "scanthree",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/ScanThree.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/scanfour",
      name: "scanfour",
      component: () =>
        import(/* webpackChunkName: "scan" */ "../views/qr/ScanFour.vue"),
      // meta: {
      //   requiresGuest: true
      // }
    },
    {
      path: "/music",
      name: "music",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/Music.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/points",
      name: "points",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/Points.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/lastmile",
      name: "lastmile",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/LastMile.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/driver",
      name: "driver",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/Driver.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sendtocar",
      name: "sendtocar",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/SendToCar.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/linkvehicle",
      name: "linkvehicle",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../components/VehicleLink.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/sendpush",
      name: "sendpush",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/SendPush.vue"),
      // meta: {
      //   requiresGuest: true
      // }
    },
    {
      path: "/pinreset",
      name: "pinreset",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/PinReset.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/cleanvin",
      name: "cleanvin",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/CleanVin.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkkeys",
      name: "dkkeys",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKKeys.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dktransportkeys",
      name: "dktransportkeys",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKTransportKeys.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkvehiclestatus",
      name: "dkvehiclestatus",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKVehicleStatus.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkvehiclestatussimple",
      name: "dkvehiclestatussimple",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKVehicleStatusSimple.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkaddvehicle",
      name: "dkaddvehicle",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKAddVehicle.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dklookupinstalled",
      name: "DKLookupInstalled",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKLookupInstalled.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkdeletekeyinfo",
      name: "DKDeleteKeyInfo",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKDeleteKeyInfo.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkresetasset",
      name: "DKResetAsset",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKResetAsset.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dkassetserial",
      name: "DKAssetSerial",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/digitalkey/DKAssetToSerial.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/frnativecrypto",
      name: "frnativecrypto",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/frnative/FRNativeCrypto.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/regvehicle",
      name: "regvehicle",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/RegisterVehicle.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/regvehicletoo",
      name: "regvehicletoo",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/RegisterVehicleToo.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/frnativetoken",
      name: "frnativetoken",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/frnative/FRNativeToken.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/frtmecreate",
      name: "frtmecreate",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/frnative/FRTMECreate.vue"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qrdeeplinks",
      name: "qrdeeplinks",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/deeplinks/QRDeepLinks.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/vehiclematchmaker",
      name: "vehiclematchmaker",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/VehicleMatchMaker.vue"),
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  fireCurrentUser().then((response) => {
    // console.log('response: ', response)
    if (requiresAuth && !response) {
      next('/login');
    } else {
      next();
    }
  })

});

export default router;
